module.exports = __webpack_public_path__ + "img/zhhb-2.fbbfbccb.png";